/* CYME CUSTOM: mobile header drawer focus restoration (#406).
   Prestige's drawer focus trap releases focus to <body> when the hamburger is
   used to close the menu. Restore the controlling button after the leave
   animation so keyboard and switch users keep their place in the header. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('header-sidebar#sidebar-menu').forEach((sidebar) => {
      if (sidebar.hasAttribute('data-cyme-focus-return')) {
        return;
      }

      sidebar.dataset.cymeFocusReturn = 'armed';
      let returnTarget = null;
      let restoreTimer = 0;

      sidebar.addEventListener('dialog:before-show', () => {
        clearTimeout(restoreTimer);
        const controls = Array.from(document.querySelectorAll('[aria-controls="sidebar-menu"]'));
        returnTarget = controls.includes(document.activeElement) ? document.activeElement : controls[0];
        sidebar.dataset.cymeFocusReturn = returnTarget ? 'captured' : 'missing-control';
      });

      sidebar.addEventListener('toggle', () => {
        if (sidebar.hasAttribute('open')) {
          return;
        }

        sidebar.dataset.cymeFocusReturn = 'scheduled';
        clearTimeout(restoreTimer);
        restoreTimer = setTimeout(() => {
          const target = returnTarget && returnTarget.isConnected
            ? returnTarget
            : document.querySelector('[aria-controls="sidebar-menu"]');

          if (!target) {
            sidebar.dataset.cymeFocusReturn = 'missing-control';
            return;
          }

          target.focus({ preventScroll: true });
          sidebar.dataset.cymeFocusReturn = document.activeElement === target ? 'restored' : 'focus-rejected';
        }, 500);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
